import BottomButton from '../../../components/Buttons/BottomButtonStyled';
import ContentBoardStyled from '../../../components/ContentBoardStyled';
import StyledBoardHeader from '../../../components/StyledBoardHeader';
import SelectInput from '../../../components/Inputs/SelectInput';
import SearchInput from '../../../components/Inputs/SearchInput';
import CountInput from '../../../components/Inputs/CountInput';
import { FiltersWrap } from '../../../components/Inputs/styles';
import useDealers from '../../../api/useDealers';
import doFetch from '../../../api/doFetch';
import React, { useEffect } from 'react';

import { isEqual } from 'lodash';
import {
  useMakes,
  useModels,
  useFilter,
  defaultValue,
  filteTorQuery,
  usePatchFilter,
  useResetFilter
} from '../context';

export default function () {
  const patchFilter = usePatchFilter();
  const resetFilter = useResetFilter();
  const { dealers } = useDealers('');
  const filter = useFilter();
  const models = useModels();
  const makes = useMakes();

  const years = [
    'Any',
    ...Array(new Date().getFullYear() - 1900 + 1)
      .fill(new Date().getFullYear())
      .map((year, index) => year - index)
      .sort((a, b) => (b < a ? -1 : 1))
  ];


  useEffect(() => {
    if (filter?.models?.length) {
      const filtered = filter.models.filter((model) => models.includes(model));
      if (filtered?.length !== filter?.models?.length) {
        patchFilter({ models: filtered });
      }
    }
    // eslint-disable-next-line
  }, [models?.length]);

  const performExport = () => {
    const changed = { ...filter };

    doFetch(`/vehicles/photos/download/csv?${filteTorQuery(changed)}`, { responseType: 'blob' })
      .then((response) => response.blob())
      .then((response) => {
        const file = new Blob([response], { type: `application/csv` });
        const fileURL = URL.createObjectURL(file);
        var a = document.createElement('a');
        a.href = fileURL;
        a.download = `vehicles-report.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch((error) => {
        alert(error);
      });
  };

  return (
    <ContentBoardStyled css={{ minHeight: '130px', marginLeft: 0, marginTop: 0 }}>
      <StyledBoardHeader
        button={{
          name: 'Reset',
          handler: resetFilter
        }}
        disabledButton={isEqual(defaultValue, filter)}
      >
        FILTER
      </StyledBoardHeader>

      <FiltersWrap p={3}>
        <SelectInput
          label={'Locations'}
          data={dealers}
          keys={{ id: 'hmsId', name: 'name', type: 'locations' }}
          selectedItems={filter.dealers}
          setSelectedItems={dealers => patchFilter({dealers})}
        />
        <SearchInput
          label='VIN'
          placeholder='Enter VIN'
          value={filter?.vin || ''}
          onChange={(vin) => patchFilter({ vin })}
        />
        <SelectInput
          label={'Make'}
          array={makes || []}
          selectedItems={filter?.makes || []}
          setSelectedItems={(makes) => patchFilter({ makes })}
          disabled={Boolean(filter?.vin)}
        />
        <SelectInput
          label={'Model'}
          array={models || []}
          selectedItems={filter?.models || []}
          setSelectedItems={(models) => patchFilter({ models })}
          disabled={Boolean(filter?.vin)}
        />
        <SelectInput
          single={1}
          label={'Year'}
          array={years}
          selectedItems={filter?.year}
          setSelectedItems={(year) => {
            patchFilter({ year });
          }}
          disabled={Boolean(filter?.vin)}
          sort={false}
        />
        <SearchInput
          label='Model Number'
          placeholder='Value'
          value={filter?.modelNumber || ''}
          onChange={(modelNumber) => patchFilter({ modelNumber })}
          disabled={Boolean(filter?.vin)}
        />
        <SearchInput
          label='Exterior Color Description'
          placeholder='Enter color'
          value={filter?.exteriorColor || ''}
          onChange={(exteriorColor) => patchFilter({ exteriorColor })}
          disabled={Boolean(filter?.vin)}
        />
        <SearchInput
          label='Interior Color Code'
          placeholder='Enter code'
          value={filter?.interiorColor || ''}
          onChange={(interiorColor) => patchFilter({ interiorColor })}
          disabled={Boolean(filter?.vin)}
        />
        <CountInput
          label={'Photo amount'}
          selectedCount={filter.photoAmount}
          setSelectedCount={(photoAmount) => patchFilter({ photoAmount })}
          disabled={Boolean(filter?.vin)}
        />
        <SearchInput
          label='MSRP'
          placeholder='Value'
          value={filter?.msrp || ''}
          onChange={(msrp) => patchFilter({ msrp })}
          disabled={Boolean(filter?.vin)}
        />
        <CountInput
          label={'Invoice Amount'}
          selectedCount={filter.invoiceAmount}
          setSelectedCount={(invoiceAmount) => patchFilter({ invoiceAmount })}
          disabled={Boolean(filter?.vin)}
        />
      </FiltersWrap>
      <BottomButton onClick={performExport} disabled={isEqual(defaultValue, filter)}>
        Export EXCEL report
      </BottomButton>
    </ContentBoardStyled>
  );
}
